import api from 'services/api';
import { bool, object, type Received } from 'validation';

import { readResponse } from 'api/shared/readResponse';

// PUT /workflows/:workflow_id/read — marks a workflow read for the inbox. Source of truth: nap-backend
// `routes/workflows.js`, which answers `{ success: true }`.

export interface UpdatedWorkflowRead {
  readonly success: boolean;
}

const updatedSchema = object<UpdatedWorkflowRead>({ success: bool() });

/** PUT `/workflows/:id/read`. Rejects on HTTP error, including the 404 for a workflow the caller may not see. */
export const putWorkflowRead = async (workflowId: number): Promise<Received<UpdatedWorkflowRead>> => {
  const res = await api.put(`/workflows/${workflowId}/read`);
  return readResponse(res.data, { schema: updatedSchema, source: 'putWorkflowRead' });
};
